module.exports = __webpack_public_path__ + "static/DSC_9504-4e67afc93ce180f83b2ca8b7e18d28be.jpg";